import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Modal,
  Pagination,
  Spinner,
} from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import axios from "axios";
import { Helmet } from "react-helmet";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 5;

  const fetchBlogs = async (p = 1) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `https://sfa-blog.onrender.com/api/blogs?page=${p}&limit=${limit}`
      );
      const fetchedBlogs = res.data.blogs || [];
      setBlogs(fetchedBlogs);
      const total = res.data.total || 0;
      setTotalPages(Math.max(1, Math.ceil(total / limit)));
      setPage(p);
    } catch (err) {
      console.error("Error fetching blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const handleOpenModal = (blog) => {
    setSelectedBlog(blog);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedBlog(null);
    setShowModal(false);
  };

  return (
    <Container className="pb-5">
       <Helmet>
                  <title>
                    Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
                  </title>
                  <meta
                    name="description"
                    content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
                  />
                </Helmet>
      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Loading blogs...</p>
        </div>
      ) : blogs.length === 0 ? (
        <p className="text-center mt-5" style={{ fontSize: "1.2rem", color: "#555" }}>
          No blogs available
        </p>
      ) : (
        <>
          <Row>
            {blogs.map((blog) => (
              <Col md={12} className="mb-4" key={blog._id}>
                <Card
                  className="shadow-lg border-0 rounded-4 blog-card"
                  onClick={() => handleOpenModal(blog)}
                  style={{ cursor: "pointer", transition: "all 0.3s ease" }}
                >
                  <Row className="g-0">
                    <Col md={4}>
                      <Card.Img
                        src={blog.imageUrl || "https://via.placeholder.com/400x250"}
                        alt={blog.metaDescription}
                        className="rounded-start"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderTopLeftRadius: "1rem",
                          borderBottomLeftRadius: "1rem",
                        }}
                      />
                    </Col>
                    <Col md={8}>
                      <Card.Body>
                        <Card.Title style={{ fontWeight: "600", fontSize: "1.3rem" }}>
                          {blog.title}
                        </Card.Title>
                        <Card.Text className="text-muted"
                          style={{
                            fontSize: "0.95rem",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}
                        >
                          {blog.content
                            ? blog.content.split(" ").slice(0, 100).join(" ") + "..."
                            : ""
                          }
                        </Card.Text>
                        <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                          <FaCalendarAlt className="me-2" />
                          {new Date(blog.createdAt).toLocaleDateString()}{" "}
                          {new Date(blog.createdAt).toLocaleTimeString()}
                        </div>
                      </Card.Body>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))}
          </Row>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4 mb-3">
              <Pagination>
                <Pagination.Prev
                  disabled={page === 1}
                  onClick={() => fetchBlogs(page - 1)}
                />
                {[...Array(totalPages)].map((_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={idx + 1 === page}
                    onClick={() => fetchBlogs(idx + 1)}
                    className="custom-page"
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  disabled={page === totalPages}
                  onClick={() => fetchBlogs(page + 1)}
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      {/* Blog Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered style={{zIndex:'1101'}}>
        {selectedBlog && (
          <>
            <Modal.Header closeButton className="border-0" style={{ background: "#f8f9fa" }}>
              <Modal.Title style={{ fontWeight: "700" }}>{selectedBlog.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <img
                src={selectedBlog.imageUrl || "https://via.placeholder.com/800x400"}
                alt={selectedBlog.title}
                className="img-fluid mb-3 rounded-3"
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
              <p className="text-muted mb-3">
                <FaCalendarAlt className="me-2" />
                {new Date(selectedBlog.createdAt).toLocaleString()}
              </p>
              <div style={{ whiteSpace: "pre-line", fontSize: "1rem", lineHeight: "1.6", color: "#333" }}>
                {selectedBlog.content}
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>

      {/* Custom CSS for hover + pagination */}
      <style>
        {`
          .blog-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          }

          .pagination .page-item.active .page-link {
            background-color: #3A0063;
            border-color: #3A0063;
            color: #fff;
          }

          .pagination .page-link {
            color: #3A0063;
          }

          .pagination .page-link:hover {
            background-color: #3A0063;
            color: #fff;
          }
        `}
      </style>
    </Container>
  );
};

export default Blogs;
